const grey = '#E6E6E6';
const pinkLight = '#FFB3B3';
const pinkChartBg = 'rgba(255,179,179, 0.5)';
const pink = '#FF7888';
const greenLight = '#21A68D';
const green = '#169185';

export { grey, pinkLight, pinkChartBg, pink, greenLight, green };



// WEBPACK FOOTER //
// ./src/colors.js